import React, { Component } from 'react';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import FormControl from 'react-bootstrap/lib/FormControl';
import Alert from 'react-bootstrap/lib/Alert';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormGroup from '../inputs/fg-input.js';
import HelpBlock from 'react-bootstrap/lib/HelpBlock';
import ButtonToolbar from 'react-bootstrap/lib/ButtonToolbar';
import Button from 'react-bootstrap/lib/Button';
import { FormattedMessage } from 'react-intl';
import StaffTypeSelector from '../inputs/staff-types-selector.js';
import TranslationService from '../../services/translation-service.js';
import BulkImport from './teacher-bulk-import.js';
import Select from 'react-select';
import ClassSelector from '../inputs/classes-selector.js';

export default class UpdateEdit extends React.Component {

    constructor(props) {
        super();
        this.state = { update: undefined, submit: props.submit || function () { } };
    }

    submit() {

        if (this.state.new != undefined) {
            TranslationService.updateUpdate(this.state.update.uid, this.state.new);
        }

        this.state.submit();
    }

    
    componentWillReceiveProps(nextProps) {
        this.props = nextProps;
        this.setState({
            update: this.props.update
        })

    }


    handleChange(obj) {
        this.setState({ new: obj.target.value });
    }

    render() {

        let submitButton = React.createElement(Button, {
            onClick: this.submit.bind(this),
            bsStyle: 'primary',
            className: "btn-block"
        }, <FormattedMessage id="ui-254" defaultMessage="Submit" />);

        var old = '';
        if (this.state.update != undefined){
            old = this.state.update.new_feild;
        }
        var nu = this.state.new || '';

        return <Row className="p-l-10 , p-r-10">
            <Row>
                <Col sm={6}>
                    <FormGroup controlId="formBasicText" >
                        <ControlLabel className="fg-label">{old}</ControlLabel>
                    </FormGroup>
                </Col>
                <Col sm={6}>
                    <FormGroup controlId="formBasicText" >
                        <FormControl value={nu} type="text" onChange={this.handleChange.bind(this)} />

                    </FormGroup>
                </Col>
            </Row>

            <Row>
                <Col sm={12}>

                </Col>
            </Row>
            <Row>
                <Col sm={8}>
                </Col>
                <Col sm={4}>{submitButton}</Col>
            </Row>
        </Row>
    }

};


// WEBPACK FOOTER //
// ./src/components/forms/update-edit.js